module.exports = __webpack_public_path__ + "img/enemy_111_004.55775820.png";